<template>
  <div class="media-wrap">
    <!-- 24.5.18 合作媒体 dxm -->
    <div class="container">
      <!-- <h2 class="h2-title">{{ $t("home.mediaPartners") }}</h2> -->
      <el-row type="flex" justify="space-between" style="align-items: end">
      <el-col :span="9">
        <h2 class="h2-title">{{ $t("home.mediaPartners") }}</h2>
      </el-col>
      <el-col :span="6">
        <div class="more" @click="tapnewsList">
          {{ $t("home.more")
          }}<img class="more-icon" src="../../../assets/more_icon.png" alt="" />
        </div>
      </el-col>
    </el-row>
      <div class="media-swiper">
        <div class="swiper-container">
          <div class="swiper-wrapper" v-if="mediaLists.length > 0">
            <div
             @click="changeDetail(item)"
              class="swiper-slide"
              v-for="(item, index) in mediaLists"
              :key="index"
            >
              <img class="img" :src="$imgUrl+item.thumb" alt="" />
            </div>
           
          </div>
          <div class="nodata">没有更多数据了～</div>
          <!-- 如果需要导航按钮 -->
          <!-- <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div> -->
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入
export default {
  props: {
    mediaLists: Array,
  },
  data() {
    return {
      list: [
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
        { img: require("../../../assets/img1.png") },
      ],
    };
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    setTimeout(() => {
      new Swiper(".swiper-container", {
        slidesPerView: 6,
        slidesPerGroup: 3,
        slidesPerColumn: 2,
        slidesPerColumnFill: "row",
        centeredSlides: true,
        centeredSlidesBounds: true,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          720: {
            slidesPerView: 3,
            slidesPerGroup: 2,
          },
          900: {
            slidesPerView: 4,
            slidesPerGroup: 2,
          },
          1000: {
            slidesPerView: 6,
            slidesPerGroup: 2,
          },
          1200: {
            slidesPerView: 6,
            slidesPerGroup: 2,
          },
        },
      });
    }, 150);
  },
  methods: {
  //zhang 查看更多 跳转新闻列表
  tapnewsList() {
      this.$router.push({
        name: "partnmeredia",
      });
    },
    changeDetail(item){
      this.$emit('changeDetail',item)
    }
  },
};
</script>
<style lang="scss" scoped>
.media-wrap {
  padding-bottom: 120px;
  .more {
    font-size: 13px;
    color: #757575;
    cursor: pointer;
    text-align: right;
    line-height: 28px;
    &:hover{
      color: #233889;
    }
    .more-icon {
      margin-bottom: -1px;
      width: 16px;
      margin-left: 14px;
    }
  }
  .media-swiper {
    width: 100%;
    height: 200px;
    overflow: hidden;
    position: relative;
    margin: 58px auto 0;
    .swiper-container {
      width: 1095px;
      position: relative;
      .nodata{
        position: absolute;
        right: 60px;
        top: 90px;
      }
    }
    .swiper-slide {
      width: 168px;
      text-align: center;
      font-size: 18px;
      background: #fff;
      height: 84px;

      /* Center slide text vertically */
      display: flex;
      justify-content: center;
      align-items: center;
      .img {
        max-width: 90%;
      }
    }
    .swiper-button-prev:after,
    .swiper-button-next:after {
      content: "";
      width: 20px;
      height: 30px;
      background: url("../../../assets/arr_left.png") no-repeat;
      background-size: 100% 100%;
    }
    .swiper-button-next:after {
      content: "";
      background: url("../../../assets/arr_right1.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
@media only screen and (max-width: 1000px) {
  .media-wrap {
    .media-swiper {
      .swiper-container {
        width: 80%;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .media-wrap {
    padding-bottom: 1rem;
    .media-swiper {
      margin: 0.5rem auto 0;
      .swiper-container {
        width: 80%;
      }
    }
  }
}
</style>